var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"video",attrs:{"width":_vm.width,"height":_vm.height,"src":_vm.source,"autoplay":_vm.autoplay,"playsinline":_vm.playsinline}})
}
var staticRenderFns = []

export { render, staticRenderFns }